/* Verolae · Stats Hero
   Port of the source site "ceylon_stats_hero" inline script:
   1) Count-up animation of every stat value when it scrolls into view — IntersectionObserver
      (threshold 0.1, rootMargin 0 0 -50px), 1200 ms easeOutQuad, exact source text restored at the end.
   2) The CTA's smoothScrollToPurchase(): when the page contains a buy box
      (product-info, .product__info-container, .product-form) the button smooth-scrolls there instead of
      navigating; on pages without one the link is simply followed.
   Dependency-free; guards against multiple instances; re-initialises on theme-editor section load. */
(function () {
  'use strict';

  var BUY_BOX_SELECTOR = 'product-info, .product__info-container, .product-form';

  function smoothScrollToPurchase() {
    var buyBox = document.querySelector(BUY_BOX_SELECTOR);
    if (!buyBox) return false;
    buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  /* The source exposed this helper globally; keep it available (without clobbering another definition). */
  if (typeof window.smoothScrollToPurchase !== 'function') {
    window.smoothScrollToPurchase = smoothScrollToPurchase;
  }

  function parseStat(el) {
    var rawText = el.getAttribute('data-value') || el.textContent.trim();
    var match = rawText.match(/^([^0-9\.]*)([0-9\.]+)(.*)$/);
    if (!match) return null;
    return {
      el: el,
      rawText: rawText,
      prefix: match[1] || '',
      targetVal: parseFloat(match[2]),
      suffix: match[3] || '',
      isFloat: match[2].indexOf('.') !== -1
    };
  }

  function animateValue(stat) {
    var duration = 1200; // Animation duration in milliseconds (1.2 seconds)
    var startTime = performance.now();

    function update(currentTime) {
      var elapsedTime = currentTime - startTime;
      var progress = Math.min(elapsedTime / duration, 1);

      // Easing: easeOutQuad
      var easeProgress = progress * (2 - progress);
      var currentVal = easeProgress * stat.targetVal;

      var formattedVal = stat.isFloat ? currentVal.toFixed(1) : Math.floor(currentVal).toString();
      stat.el.textContent = stat.prefix + formattedVal + stat.suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        stat.el.textContent = stat.rawText; // Ensure exact final value
      }
    }

    requestAnimationFrame(update);
  }

  function initCounters(root) {
    var counters = root.querySelectorAll('.stats-counter-js');
    if (counters.length === 0) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (root.getAttribute('data-animate') === 'false' || reduceMotion || !('IntersectionObserver' in window)) {
      return; // keep the final values that Liquid rendered
    }

    var parsedStats = [];
    Array.prototype.forEach.call(counters, function (el, index) {
      var stat = parseStat(el);
      parsedStats[index] = stat;
      // Initialise display value to 0
      if (stat) el.textContent = stat.prefix + (stat.isFloat ? '0.0' : '0') + stat.suffix;
    });

    // Intersection Observer to trigger counter animation when the stat is viewed
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var index = Array.prototype.indexOf.call(counters, entry.target);
        if (parsedStats[index]) animateValue(parsedStats[index]);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    Array.prototype.forEach.call(counters, function (counter) {
      observer.observe(counter);
    });
  }

  function initSection(root) {
    if (!root || root.getAttribute('data-stats-hero-init') === 'true') return;
    root.setAttribute('data-stats-hero-init', 'true');

    var cta = root.querySelector('.stats-hero-cta-btn');
    if (cta && cta.getAttribute('data-scroll-to-purchase') === 'true') {
      cta.addEventListener('click', function (event) {
        if (smoothScrollToPurchase()) event.preventDefault();
      });
    }

    initCounters(root);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.verolae-stats-hero[data-verolae-stats-hero]');
    Array.prototype.forEach.call(nodes, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: (re)initialise a freshly (re)rendered section */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
